module.exports = __webpack_public_path__ + "static/media/UniversityofSheffield.6fb0d08a.png";